import React from "react";
import inc from "ramda/src/inc";

import { Grid } from "../../UI/Grid";
import { Table } from "../../UI/Table";
import { TableRow } from "../../UI/TableRow";
import { TableHead } from "../../UI/TableHead";
import { TableCell } from "../../UI/TableCell";
import { Typography } from "../../UI/Typography";

import { EnhancedTableBody } from "../EnhancedTableBody";
import { ModalProvider } from "../../contexts/ModalContext";
import { UserNameLink } from "../UserNameLink";
import { TableHeader } from "../TableHeader";
import { COLOR_WHITE, COLOR_WELL_READ } from "../../constants/styles";

interface IProps {
  groups: any[];
  isApt: boolean;
  matchGroupAtLimit: boolean;
  reloadResults: VoidFunction;
}
interface EngNumbers {
  [key: string]: any
}

const ENG_NUMBERS:EngNumbers = {
  "1": "First",
  "2": "Second"
};

const areGroupsEqualTo = (groups: any[], value: number = 1) => {
  let areEqual = true;
  for (let i = 0; i < groups.length; i++) {
    if(groups[i].roomOccupants?.length > value) {
      areEqual = false;
      break;
    }
  }
  return areEqual;
};

export const SelectedGroupsTable: React.FC<IProps> = (props) => (
  <Grid container spacing={2}>
    <Grid item xs={12}>
      <Typography variant="h6">Selected Groups</Typography>
    </Grid>
    {props.groups.map((group, idx) => (
      <Grid item xs={12} key={idx}>
        <TableHeader>
          <Typography fontWeight={600} color={COLOR_WHITE}>
            {ENG_NUMBERS[inc(idx).toString()]} Group
          </Typography>
        </TableHeader>
        <Table>
          <TableHead secondary>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Gender</TableCell>
              <TableCell>Resident Status</TableCell>
            </TableRow>
          </TableHead>
          <EnhancedTableBody colSpan={5}>
            {group.roomOccupants.map((occupant: any, idx: number) => (
              <TableRow key={occupant.uid}>
                <TableCell>
                  <ModalProvider>
                    <UserNameLink openNewTab name={occupant.name} id={occupant.uid} />
                  </ModalProvider>
                </TableCell>
                <TableCell>{occupant.sex}</TableCell>
                <TableCell>{occupant.renewing ? "Renewing Resident" : "New Resident"}</TableCell>
              </TableRow>
            ))}
          </EnhancedTableBody>
        </Table>
      </Grid>
    ))}

    {props.matchGroupAtLimit && props.groups?.length > 1 && areGroupsEqualTo(props.groups) &&
     (<Typography mt={2} ml={2} fontWeight={600} color={COLOR_WELL_READ}>
      Max number of match groups has been reached for this Unit Type. Are you sure you want to create this match?
    </Typography>)}
  </Grid>
);
